import React from 'react';
export function RegisterAccount () {
  return (
    <>
      <div>
        <img src="" alt="" />
        <h1>RegisterAccount</h1>
        <p>lorem ipsum</p>
      </div>
    </>
  );
}
